// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"AdBridgeVersion__statusIcon","details":"AdBridgeVersion__details","agentType":"AdBridgeVersion__agentType"};